<template>
  <div class="pt-40px pb-47px comapny-bg mt-40px">
    <div class="max-w mx-auto text-white">
      <p class="text-40px text-center font-bold leading-normal">赋能原厂</p>
      <p class="text-22px text-center mt-16px relative text-white mb-38px">
        品牌新机遇 合作创未来
        <router-link to="/semiconductor/list"
          class="absolute right-400px top-2px leading-22px text-14px text-white cursor-pointer">了解更多 <i
            class="el-icon-d-arrow-right"></i>
        </router-link>
      </p>
      <div class="mx-100px">
        <div class="justify-around flex">
          <div class="bg-white rounded-6px comapny-shadow px-30px pt-30px w-230px" v-for="(item, index) in companyList"
            :key="item.name">
            <div>
              <div class="flex justify-center items-center flex-col">
                <el-image :src="item.logo" class="w-200px h-78px " fit="fill"></el-image>
                <p class="text-center leading-22px text-14px mt-4 mb-6 text-[#333]">{{ item.name }}</p>
              </div>

              <el-divider>主营</el-divider>
              <div class="mt-2">
                <div v-for="(item2, index2) in item.mainBussiness" :key="index2" class="mb-2 text-center">
                  <el-tag class="!leading-18px" type="success" size="mini"> {{ item2 }} </el-tag>
                </div>
              </div>
              <div class="my-6 text-center">
                <router-link :to="`/semiconductor/${item.supplierId}`"
                  class="leading-22px text-14px text-[#909399] text-center">了解更多 <i
                    class="el-icon-d-arrow-right"></i></router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const companyList = ref([
  {
    logo: 'https://download.zhidiancloud.com/zd/images/20250310/1741591148488.jpg',
    name: '奉加科技（上海）股份有限公司',
    mainBussiness: ['Bluetooth LE',  'Wireless MCU'],
    supplierId: '1898988265697816576',
  },

  {
    logo: 'https://download.zhidiancloud.com/zd/images/20250108/1736301655520.png',
    name: '重庆平创半导体研究院有限责任公司',
    mainBussiness: ['SiC 分立部件', 'SiC 功率模块'],
    supplierId: '1856219218338230147',
  },
  {
    logo: 'https://download.zhidiancloud.com/mro/images/20240415/1713158587042.png',
    name: '浙江晶河科技有限公司',
    mainBussiness: ['WIFi6模组', '数字传感器'],
    supplierId: import.meta.env.VITE_APP_ENV === 'development' ? '1602548134529044480' : '1772154251035357183',
  },
  // {
  //   logo: 'https://download.zhidiancloud.com/mro/images/20240415/1713158604613.png',
  //   name: '芯象半导体科技（乐清）有限公司',
  //   mainBussiness: ['集中器路由模块', '载波核心通信模组'],
  //   supplierId: import.meta.env.VITE_APP_ENV === 'development' ? '1602548134529044480' : '1772154248635357845',
  // },
  // {
  //   logo: 'https://download.zhidiancloud.com/mro/images/20240415/1713158613745.png',
  //   name: '无锡利普思半导体有限公司',
  //   mainBussiness: ['SiC模块', 'IGBT模块'],
  //   supplierId: import.meta.env.VITE_APP_ENV === 'development' ? '1602548134529044480' : '1772154251035357185',
  // },
]);
</script>

<style scoped>
.comapny-bg {
  /* https://download.zhidiancloud.com/mro/images/20240415/1713156167726.png */
  background: url('https://download.zhidiancloud.com/mro/images/20240415/1713156167726.png') center no-repeat;
  background-size: cover;
}
.comapny-shadow {
  box-shadow: 0px 2px 12px 0px rgba(100, 101, 102, 0.12);
}

:deep() .el-divider__text {
  color: #909399 !important;
}
:deep() .el-tag.el-tag--success {
  color: #06c167;

  background-color: #e6f9f0;
  border-color: #b4ecd1;
}
</style>
